/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneKeesingGames as ResolvedStandaloneKeesingGames } from 'base/components/standalone/KeesingGames';

export const KeesingGames: typeof ResolvedStandaloneKeesingGames = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneKeesingGames {...props} />
        </ErrorBoundary>
    );
});

export type KeesingGamesProps = PropsFromComponent<typeof KeesingGames>;

/** @deprecated Use slot architecture instead */
export const KeesingGamesWith = (extras: DynamicStandaloneExtras): typeof KeesingGames => {
    return function KeesingGames(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'KeesingGames');
        return <ResolvedStandaloneKeesingGames {...mergeProps({ options: { theme } }, props)} />;
    }
}